<h3>Repairers</h3>

<section class="my-20 mx-15">
  @for (site of currentUserService.currentUserValue.repairerSites; track site.id) {
    <mat-card
      class="p-10! flex flex-col justify-between hover:cursor-pointer"
      [ngClass]="{ 'pointer-events-none': !['ACTIVE', 'SUSPENDED', 'UNAVAILABLE'].includes(site?.status) }"
      (click)="accessRepairSite(site)">
      <div class="flex flex-col items-stretch gap-10">
        <span class="subtitle-1">{{ site?.companyName }}</span>
        <div class="flex items-center body-2">
          <mat-icon class="size-14! text-14! mr-5">account_circle</mat-icon>
          <span class="text-charcoal-50">{{ site?.mainContact.firstName }} {{ site?.mainContact.lastName }}</span>
        </div>
        <div class="flex items-center body-2">
          <mat-icon class="size-14! text-14! mr-5">call</mat-icon>
          <span class="text-charcoal-50">{{ site?.phoneNumber }}</span>
        </div>
        <div class="flex body-2">
          <mat-icon class="size-14! text-14! mr-5">home</mat-icon>
          <span class="text-charcoal-50">{{ site?.addressString }}</span>
        </div>
      </div>
      <div class="flex justify-end mt-10">
        <div
          class="rounded-full body-1 px-30 py-10 text-white"
          [ngClass]="{
            'bg-green': site?.status === 'ACTIVE',
            'bg-orange': site?.status === 'PENDING',
            'bg-neut-var-60': ['SUSPENDED', 'UNAVAILABLE'].includes(site?.status),
            'bg-red': site?.status === 'ARCHIVED'
          }">
          {{
            site?.status === 'UNAVAILABLE'
              ? (unavailabilityTypeEnum[site?.unavailabilityType] | uppercase)
              : site?.status
          }}
        </div>
      </div>
    </mat-card>
  }
</section>
